import styled from "styled-components";

export const Container = styled.div`
	padding: 0 2rem;
`;
export const ContainerButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: 1rem;

	> button {
		padding: 0.4rem 1rem;
		> span {
			display: flex;
			flex-direction: row;
			justify-content: center;
			gap: 1rem;
			font-size: 0.8rem;
		}
	}
`;
